import React, {Component} from 'react';
import {Row, Col} from "react-bootstrap";
import CenyBiletowSelectFrom from "./components/CenyBiletowSelectFrom";
import CennikBiletowService from "../CennikBiletowService";
import DefinicjeService from "../../../trasyConfig/definicjeTras/DefinicjeService";
import CenyBiletowMacierz from "./components/CenyBiletowMacierz";
import TopIf from "../../../../../componentsTopsa/if/TopIf";
import {TopButtonAction} from "../../../../../componentsTopsa/buttons/TopButtons";
import ReactNotify from 'react-notify';
import {TopAlertSukces, TopAlertUwaga} from "../../../../../componentsTopsa/alerty/TopAlerts";
import moment from "moment";

export default class PokazCennikContainer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            editable: false,
            cennik: [],
            selectedData: null,
            miejscowosciNaTrasie: [],
            obecna_trasa: null,
            obecna_znizka: null,
            obecna_data: null,
            ponowneWyszukanie: false,
            wyszukajCennik: null,
            czyWyczyscicCennik: false,
            pokazInfoPoCzyszczeniu: false,
        }
        this.onClickPokaz = this.onClickPokaz.bind(this)
        this.pobierzCennik = this.pobierzCennik.bind(this)
        this.pobierzMiejscowosciNaTrasie = this.pobierzMiejscowosciNaTrasie.bind(this)
        this.onEdytujPoszczegolnaCene = this.onEdytujPoszczegolnaCene.bind(this)
        this.ukryjCennik = this.ukryjCennik.bind(this)
    };


    componentDidMount() {
        this.ustawWyszukanieCennikaZKonfiguracji(this.props)
    }

    componentWillReceiveProps(nextprops) {
        this.ustawWyszukanieCennikaZKonfiguracji(nextprops)
    }

    ustawWyszukanieCennikaZKonfiguracji(props) {
        if (Boolean(props.wyszukajCennik)) {

            let trasa = this.props.trasy.find(t => t.idTr === props.wyszukajCennik.id_tr)
            let znizka = this.props.znizki.find(t => t.rodz === props.wyszukajCennik.rodz)
            let obecnadata = {data: props.wyszukajCennik.data}

            this.setState({
                wyszukajCennik: props.wyszukajCennik,
                obecna_trasa: trasa,
                obecna_znizka: znizka,
                obecna_data: obecnadata,
            })
            DefinicjeService.pobierzMiejscowosciNaTrasie(props.wyszukajCennik.id_tr).then(function (response) {
                this.setState({miejscowosciNaTrasie: [{}, ...response.data]})

                CennikBiletowService.getCennik(props.wyszukajCennik.id_tr, props.wyszukajCennik.rodz, props.wyszukajCennik.data).then(function (res) {
                    this.setState({cennik: res.data})
                }.bind(this))
            }.bind(this))

        }
    }

    pobierzMiejscowosciNaTrasie(trasa) {
        DefinicjeService.pobierzMiejscowosciNaTrasie(trasa.idTr).then(function (response) {
            this.setState({miejscowosciNaTrasie: [{}, ...response.data]})
        }.bind(this))
    }

    pobierzCennik(trasa, znizka, data) {

        let szukanadata = null;

        if (Boolean(data)) {
            szukanadata = data.data
        }

        CennikBiletowService.getCennik(trasa.idTr, znizka.rodz, szukanadata).then(function (response) {
            this.setState({cennik: response.data})
        }.bind(this))
    }

    onClickPokaz(trasa, znizka, data) {

        let editable = false

        if (moment(this.state.selectedData.data).format('YYYY-MM-DD') > moment().format('YYYY-MM-DD')){
            editable = true
        }

        this.pobierzCennik(trasa, znizka, data)
        this.pobierzMiejscowosciNaTrasie(trasa)
        this.setState({
            obecna_trasa: trasa,
            obecna_znizka: znizka,
            obecna_data: data,
            editable: editable,
            wyszukajCennik: null,
            czyWyczyscicCennik: false,
            pokazInfoPoCzyszczeniu: false
        })
        if (this.state.obecna_trasa || this.state.obecna_znizka) {
            // nastąpiło ponowne wyszukanie
            this.setState({ponowneWyszukanie: true})
        }
    }

    onEdytujPoszczegolnaCene(miejscowoscOd, miejscowoscDo, nowa_cena, cena) {

        // przestawiono na krzyż (miejscowosc do -> miejscowosc od) aby pasowalo do odwrotnie wyswietlonej macierzy

        if (Boolean(cena)) {
            // edycja
            let data = {
                "idC": cena.idC,
                "cena": parseFloat(nowa_cena),
                "dataOd": this.state.obecna_data.data,
                "idMiDo": miejscowoscOd.idMi,
                "idMiOd": miejscowoscDo.idMi,
                "idTr": this.state.obecna_trasa.idTr,
                "rodz": this.state.obecna_znizka.rodz,
            }

            CennikBiletowService.editCena(cena.idC, data).then(function (response) {
                this.pobierzCennik(this.state.obecna_trasa, this.state.obecna_znizka, this.state.obecna_data)
            }.bind(this))

        }
        else {
            // dodanie
            let data = {
                "cena": parseFloat(nowa_cena),
                "dataOd": this.state.obecna_data.data,
                "idMiDo": miejscowoscOd.idMi,
                "idMiOd": miejscowoscDo.idMi,
                "idTr": this.state.obecna_trasa.idTr,
                "rodz": this.state.obecna_znizka.rodz,
            }


            CennikBiletowService.addCena(data).then(function (response) {
                this.pobierzCennik(this.state.obecna_trasa, this.state.obecna_znizka, this.state.obecna_data)
            }.bind(this))
        }
    }

    ukryjCennik() {
        this.setState({
            cennik: [],
            miejscowosciNaTrasie: [],
        })
    }

    onClickPrzepiszCennik(data, trasa, rodz) {
        CennikBiletowService.przepiszNaCennikPowrotny(data, rodz, trasa).then(function (response) {
            if (response.status < 300) {
                this.refs.notificator.success("Pomyślnie przepisano cennik", "", 3000);
            }
            else {
                this.refs.notificator.error("Wystąpił błąd podczas przepisywania cennika ", "", 3000);
            }
        }.bind(this))
    }

    onClickUsunCennik(data, trasa, rodz) {
        if (window.confirm('Czy na pewno chcesz usunąć ten cennik?')) {
            CennikBiletowService.usunDanyCennik(trasa, data, rodz).then(function (response) {
                if (response.status < 300) {
                    this.setState({
                        cennik: [],
                        miejscowosciNaTrasie: [],
                        obecna_trasa: null,
                        obecna_znizka: null,
                        obecna_data: null,
                        ponowneWyszukanie: false,
                        wyszukajCennik: null,
                        czyWyczyscicCennik: true,
                        pokazInfoPoCzyszczeniu: 'ok'
                    })
                } else {
                    this.setState({
                        pokazInfoPoCzyszczeniu: 'error'
                    })
                }
            }.bind(this)).catch(err => {
                this.setState({
                    pokazInfoPoCzyszczeniu: 'error'
                })
            })
        }
        console.log(data, trasa, rodz)
    }

    render() {

        return (
            <Row>
                <ReactNotify ref='notificator'/>
                <Col xs={12}>
                    <CenyBiletowSelectFrom dataSelect={(e)=>{this.setState({selectedData: e})}} trasy={this.props.trasy} znizki={this.props.znizki} handlePokaz={this.onClickPokaz}
                                           ukryjCennik={this.ukryjCennik} wyszukajCennik={this.state.wyszukajCennik}
                                           wyczyscFormularzSzukania={this.state.czyWyczyscicCennik}
                                           przerwijCzyszczenieSzukania={() => {
                                               this.setState({czyWyczyscicCennik: false})
                                           }}
                    />
                </Col>
                {
                    Boolean(this.state.pokazInfoPoCzyszczeniu) ?
                        <Col xs={12}>
                            {
                                this.state.pokazInfoPoCzyszczeniu === 'error' ?
                                    <TopAlertUwaga text={'Wystąpił błąd podczas usuwania cennika'}/>
                                    :
                                    <TopAlertSukces text={'Pomyślnie usunięto cennik - wyczyszczono pola wyszukiwania.'}/>
                            }
                        </Col>
                        :
                        ''
                }
                {

                    (this.state.miejscowosciNaTrasie.length > 0) ?
                        Boolean(this.state.wyszukajCennik) ?
                            <Col xs={12} style={{textAlign: 'center'}}>
                                <h4>
                                    {
                                        ((this.state.wyszukajCennik.rodz !== 'BASE') && (this.state.wyszukajCennik.rodz !== 'BASEM')) ?
                                            <div className={'pull-left'}>
                                                <TopButtonAction text={'Usuń cennik'} iconType={'fa fa-trash'} btnColor={'danger'} onClick={
                                                    () => {
                                                        this.onClickUsunCennik(this.state.wyszukajCennik.data, this.state.wyszukajCennik.id_tr, this.state.wyszukajCennik.rodz)
                                                    }}/>
                                            </div>
                                            :
                                            ''
                                    }
                                    <span>
                                    Cennik na trasie <span className={'label label-ebus-primary'}
                                                           style={{fontSize: 'inherit'}}>{this.state.wyszukajCennik.naz_tr}</span> dla zniżki <span
                                        className={'label label-ebus-default'}
                                        style={{fontSize: 'inherit'}}>{this.state.wyszukajCennik.rodz}</span> ważny
                                    od {this.state.wyszukajCennik.data}
                                    </span>
                                    <div className={'pull-right'}>
                                        <TopButtonAction text={'Przepisz cennik na trasę powrotną'} iconType={'fa fa-clone'} onClick={
                                            () => {
                                                this.onClickPrzepiszCennik(this.state.wyszukajCennik.data, this.state.wyszukajCennik.id_tr, this.state.wyszukajCennik.rodz)
                                            }}/>
                                    </div>
                                </h4>
                            </Col>
                            :
                            (Boolean(this.state.obecna_data) && Boolean(this.state.obecna_znizka) && Boolean(this.state.obecna_trasa)) ?
                                <Col xs={12} style={{textAlign: 'center'}}>
                                    <h4>
                                        {
                                            ((this.state.obecna_znizka.rodz !== 'BASE') && (this.state.obecna_znizka.rodz !== 'BASEM')) ?
                                                <div className={'pull-left'}>
                                                    <TopButtonAction text={'Usuń cennik'} iconType={'fa fa-trash'} btnColor={'danger'} onClick={
                                                        () => {
                                                            this.onClickUsunCennik(this.state.obecna_data.data, this.state.obecna_trasa.idTr, this.state.obecna_znizka.rodz)
                                                        }}/>
                                                </div>
                                                :
                                                ''
                                        }

                                        <span>
                                        Cennik na trasie <span className={'label label-ebus-primary'}
                                                               style={{fontSize: 'inherit'}}>{this.state.obecna_trasa.nazTr}</span> dla zniżki <span
                                            className={'label label-ebus-default'}
                                            style={{fontSize: 'inherit'}}>{this.state.obecna_znizka.rodz}</span> ważny od {this.state.obecna_data.data}
                                        </span>
                                        <div className={'pull-right'}>
                                            <TopButtonAction text={'Przepisz cennik na trasę powrotną'} iconType={'fa fa-clone'} onClick={
                                                () => {
                                                    this.onClickPrzepiszCennik(this.state.obecna_data.data, this.state.obecna_trasa.idTr, this.state.obecna_znizka.rodz)
                                                }}/>

                                        </div>
                                    </h4>
                                </Col>
                                :
                                ''
                        :
                        ''
                }
                <Col xs={12}>
                    <TopIf isTrue={this.state.miejscowosciNaTrasie.length > 0}>

                                <CenyBiletowMacierz editable={this.state.editable} cennik={this.state.cennik} miejscowosci={this.state.miejscowosciNaTrasie}
                                                    handleEdytujCene={this.onEdytujPoszczegolnaCene} ponowneWyszukanie={this.state.ponowneWyszukanie}
                                                    handleDezaktywujPonowneWyszukiwanie={() => this.setState({ponowneWyszukanie: false})}/>

                    </TopIf>
                </Col>
            </Row>
        );
    }
}




// WEBPACK FOOTER //
// ./src/modules/konfiguracja/biletyConfig/cenyBiletow/pokazCennik/PokazCennikContainer.js